<br />
<br />
<br />
<br />
<div class="art">
  <div class="text-center ">
    <h2 class="titlle">{{ 'career.title' | translate }}</h2>
    <p class="subtitle mt-3 text-center" [innerHTML]="'career.subtitle' | translate">
    </p>

    <!-- <h2 class="titlle">Career Insights That Help You Stand Out</h2>
    <p class="subtitle mt-3 text-center">
      Explore expert articles on CV writing, LinkedIn management, job applications, and more. <br> Stay ahead with
      practical tips and AI-powered career advice.
    </p> -->
  </div>
  <!-- <div class="row mx-4" *ngIf="articles.length">
  <div
    class="col-12 col-sm-6 col-md-4 col-lg-3 p-3"
    *ngFor="let article of articles"
  >
    <div class="card" routerLink="{{ '/articleDetails/' + article.articleId }}">
      <img
        [src]="getFullImageUrl(article.imageUrl)"
        class="card-img-top"
        alt="{{ article.title }}"
      />

      <h4 class="card-title mx-2 mt-2">{{ article.title }}</h4>
      <p class="card-text mx-2 mb-2">
        {{ article.description }}
      </p>
    </div>
  </div>
</div>

<h3 *ngIf="articles.length === 0" class="mt-5 text-center">
  {{ "No Articles Yet" | translate }}
</h3> -->
  <div class="articles-grid mt-3" *ngIf="articles.length">
    <!-- <div class="card" *ngFor="let article of articles">
  <div class="card-img">
    <img [src]="article.imageUrl" alt="career-img" />
  </div>

    <p class="date">{{ article.date }}</p>
    
    <div class="header">
      <h3 class="card-title">{{ article.title }}</h3>
      <button class="redirect-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none">
          <path d="M12.766 10.7173C12.5115 10.7311 12.2663 10.8444 12.0833 11.0326C11.9003 11.2208 11.7943 11.4688 11.7881 11.7232C11.7818 11.9775 11.8759 12.2178 12.05 12.3922C12.224 12.5666 12.4641 12.6611 12.7185 12.6553L20.0284 12.3709L10.3623 22.0371C10.1748 22.2246 10.0648 22.4744 10.0567 22.7315C10.0486 22.9886 10.1429 23.2319 10.319 23.408C10.495 23.584 10.7384 23.6784 10.9955 23.6703C11.2526 23.6621 11.5024 23.5522 11.6899 23.3647L21.3518 13.7028L21.067 21.0038C21.0612 21.2582 21.1557 21.4983 21.3301 21.6724C21.5045 21.8464 21.7448 21.9405 21.9992 21.9343C22.2535 21.928 22.5016 21.822 22.6898 21.639C22.8779 21.4561 22.9912 21.2109 23.0051 20.9563L23.3734 11.5312C23.3795 11.3706 23.3538 11.2124 23.2975 11.0658C23.2413 10.9192 23.1558 10.7871 23.0458 10.6772C22.9359 10.5672 22.8038 10.4817 22.6572 10.4254C22.5106 10.3692 22.3524 10.3434 22.1918 10.3496L12.766 10.7173Z" fill="white"/>
        </svg>
      </button>
    </div>
    
    <ul>
      <li *ngFor="let point of article.points">{{ point }}</li>
    </ul>
  </div> -->
    <div class="card" *ngFor="let article of articles">
      <div class="card-img">
        <img [src]="getFullImageUrl(article.mainImage)" alt="career-img" />
      </div>

      <div class="card-body">
        <p class="date">{{ article.createdAt | date:'dd MMM yyyy' }}</p>

        <div class="header">
          <h3 class="card-title">{{ loadArticleContent(article) }}</h3>
          <button class="redirect-btn" (click)="goToDetails(article.id)"> <svg xmlns="http://www.w3.org/2000/svg"
              width="34" height="35" viewBox="0 0 34 35" fill="none">
              <path
                d="M12.766 10.7173C12.5115 10.7311 12.2663 10.8444 12.0833 11.0326C11.9003 11.2208 11.7943 11.4688 11.7881 11.7232C11.7818 11.9775 11.8759 12.2178 12.05 12.3922C12.224 12.5666 12.4641 12.6611 12.7185 12.6553L20.0284 12.3709L10.3623 22.0371C10.1748 22.2246 10.0648 22.4744 10.0567 22.7315C10.0486 22.9886 10.1429 23.2319 10.319 23.408C10.495 23.584 10.7384 23.6784 10.9955 23.6703C11.2526 23.6621 11.5024 23.5522 11.6899 23.3647L21.3518 13.7028L21.067 21.0038C21.0612 21.2582 21.1557 21.4983 21.3301 21.6724C21.5045 21.8464 21.7448 21.9405 21.9992 21.9343C22.2535 21.928 22.5016 21.822 22.6898 21.639C22.8779 21.4561 22.9912 21.2109 23.0051 20.9563L23.3734 11.5312C23.3795 11.3706 23.3538 11.2124 23.2975 11.0658C23.2413 10.9192 23.1558 10.7871 23.0458 10.6772C22.9359 10.5672 22.8038 10.4817 22.6572 10.4254C22.5106 10.3692 22.3524 10.3434 22.1918 10.3496L12.766 10.7173Z"
                fill="white" />
            </svg></button>
        </div>

        <p class="card-desc">{{ loadArticleDesc(article) }}</p>
      </div>
    </div>

  </div>
</div>